import * as React from "react"

// @ts-ignore
import { saBoxes, saBoxesTitleContainer, saBoxesTextContainer, saBoxesTitle, saBoxesBtn } from "./saBoxes3.module.scss"
// @ts-ignore
import { saBoxes3Blocks } from "./../saIcons/saListIconsWithText.module.scss"

import { SaTitle } from "../saTitle/saTitle"
import { SaSubtitle } from "../saTitle/saSubtitle"
import { saInterfacesBoxes3 } from "../saTypes"
import { SaListIconsWithText } from "../saIcons/saListIconsWithText"
import { SaButton } from "../saButton/saButton"


export const SaBoxes3: React.FC<saInterfacesBoxes3> = ({ ...props }) =>  {

    //console.log(props.blocks)

    let gridDesk: string = ' gridDesk-2'
    let gridTab: string = ' gridTab-2'
    let gridMob: string = ' gridMob-1'

    if (props.gridDesk){
      gridDesk = ' gridDesk-' + props.gridDesk
    }

    if (props.gridTab){
      gridTab = ' gridTab-' + props.gridTab
    }

    if (props.gridMob){
      gridMob = ' gridMob-' + props.gridMob
    }


    return (
      <div className={'saContainer ' + saBoxes}>

        {
          props.sectionTitle &&
          <div className={saBoxesTitleContainer}>
            <SaTitle title={props.sectionTitle} classes={saBoxesTitle}/>
          </div>
        }

        {
          props.subtitle &&
          <div className={saBoxesTextContainer}>
            <SaSubtitle title={props.subtitle} classes={saBoxesTitle}/>
          </div>
        }

        {
          props.blocks &&
          <div className={saBoxes3Blocks + gridDesk + gridTab + gridMob}>
            <SaListIconsWithText {...props.blocks}/>
          </div>
        }

        {
          props.button &&
          <div className={saBoxesBtn}>
            <SaButton {...props.button}/>
          </div>
        }


      </div>
    )

}
